import {
	axiosDelete,
	axiosGet,
	axiosPost,
	axiosPut,
} from '../../services/axiosService';

const baseStaticPagesURL = 'StaticPages';

export class StaticPageService {
	getStaticPages(currentPage = 1, perPage = 10) {
		return axiosGet(
			null,
			`${baseStaticPagesURL}/?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}`
		);
	}

	getStaticPageDetail(id) {
		return axiosGet(null, `${baseStaticPagesURL}/Edit/${id}`);
	}

	addStaticPage(values) {
		return axiosPost(values, baseStaticPagesURL);
	}

	updateStaticPage(id, values) {
		return axiosPut(values, `${baseStaticPagesURL}/${id}`);
	}

	deleteStaticPage(id) {
		return axiosDelete(`${baseStaticPagesURL}/${id}`);
	}
}
